import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

let firebaseApp;

export function getFirebaseApp() {
  if (!firebaseApp) {
    firebaseApp = initializeApp(getFirebaseConfig());
  }

  return firebaseApp;
}

export function getFirebaseStorage() {
  return getStorage(getFirebaseApp());
}

export function getFirebaseFunctions() {
  return getFunctions(
    getFirebaseApp(),
    process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || 'us-central1',
  );
}

function getFirebaseConfig() {
  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
  };

  const missingConfig = Object.entries(firebaseConfig)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missingConfig.length > 0) {
    throw new Error(`Missing Firebase environment values: ${missingConfig.join(', ')}`);
  }

  return firebaseConfig;
}
